import { Component, ViewEncapsulation, OnInit, Input, ElementRef, ViewChild, Output, EventEmitter, forwardRef } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { NG_VALUE_ACCESSOR, ControlValueAccessor, NG_VALIDATORS, Validator, AbstractControl, ValidationErrors } from "@angular/forms";
import { Utils } from "../common/utils";

/**
 * å¾çä¸ä¼ ç»ä»¶ - æ¯æNgModelåreactive forms
 * 
 * <example-url>https://stackblitz.com/edit/np-img-upload-sample?embed=1&file=src/app/app.component.html</example-url>
 */
@Component({
  selector: `np-img-upload`,
  templateUrl: 'img-upload.html',
  styleUrls: ['img-upload.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NpImgUpload),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => NpImgUpload),
      multi: true,
    }],
  encapsulation: ViewEncapsulation.None
})

export class NpImgUpload implements OnInit, ControlValueAccessor, Validator {
  private emitChange = (_: any) => { };

  /**æ ç­¾ */
  @Input() label: string = 'éæ©å¾ç';

  /**æ¯å¦ç¦ç¨ */
  @Input() isDisabled: boolean;

  /**æ¯å¦å¿½ç¥å®½é«æ£æ¥ï¼true - å¿½ç¥å®½é«æ£æ¥ï¼false - æ£æ¥å®½é«  */
  @Input() ignoreWidthAndHeightCheck: boolean = false;

  /**æ¯å¦å¿å¡« - å¿å¡«åæçº¢è²*å·å¨æ ç­¾åé¢ï¼å¦åæ²¡æ */
  @Input() isRequired: boolean;

  /**ä¸ä¼ å¾çæé®æå­ */
  @Input() btnText: string = 'ç¹å»ä¸ä¼ ';

  /**å¾çæè¿°ï¼å¦å°ºå¯¸ãæ ¼å¼ãå¤§å°ç­ */
  @Input() imgDesc: string = '*å¾çæè¿°ï¼å¦å°ºå¯¸ãæ ¼å¼ãå¤§å°ç­*';

  /**å¾çæ ¼å¼ï¼é»è®¤jpgãpngåjpeg */
  @Input() imgFormat: string = 'jpg|png|jpeg';

  /**å¾çå¤§å°ï¼é»è®¤æå¤§500kb */
  @Input() maxSize: number = 500;

  /**å¾çå®½åº¦px */
  @Input() width: number;

  /**å¾çé«åº¦px */
  @Input() height: number;

  /**éè¯¯ä¿¡æ¯ - å°ä»¥çº¢è²å­ä½æ¾ç¤ºå¨ä¸ä¼ æé®ä¸æ¹ */
  @Input() errorMessage: string;


  /**å½éæ°éæ©å¾çæ¶è§¦å */
  @Output() onImgFileChanged = new EventEmitter<any>();

  /**ä¸ä¼ éè¯¯ï¼å¦å°ºå¯¸ä¸å¯¹ãæ ¼å¼ä¸å¯¹ï¼å¤§å°ä¸å¯¹ç­ */
  @Output() onUploadError = new EventEmitter<string>();

  /**ç¹å»ç¼©ç¥å¾æ¯è§¦å */
  @Output() onImgClicked = new EventEmitter<any>();

  currentImgFile: File = null;
  currentImgSrc: any = null;

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit() {

  }

  onCurrentImgFileChanged(file: File) {
    const filename = file.name;
    const reg = new RegExp(`\.(${this.imgFormat.toLowerCase()})|.(${this.imgFormat.toUpperCase()})$`);
    if (!reg.test(filename)) {
      this.errorMessage = 'å¾çæ ¼å¼ä¸å¯¹ï¼æ¯æ' + this.imgFormat.split('|').join('ã');
      this.onUploadError.next(this.errorMessage);
      this.emitChange({ file: null, src: null });
      return;
    }

    if (file.size > +this.maxSize * 1024) {
      this.errorMessage = 'å¾çå¤§äº' + this.maxSize + 'kbï¼è¯·éæ°éæ©';
      this.onUploadError.next(this.errorMessage);
      this.emitChange({ file: null, src: null });
      return;
    }

    Utils.checkImgWidthAndHeight(file, +this.width, +this.height).subscribe(res => {
      if (!res && !this.ignoreWidthAndHeightCheck) {
        this.errorMessage = 'å¾çå¤§å°å¿é¡»ä¸º' + this.width + '*' + this.height;
        this.onUploadError.next(this.errorMessage);
        this.emitChange({ file: null, src: null });
        return;
      }

      this.errorMessage = '';
      this.currentImgSrc = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(file));
      this.currentImgFile = file;

      this.emitChange({ file: this.currentImgFile, src: this.currentImgSrc });
      this.onImgFileChanged.next({ file: this.currentImgFile, src: this.currentImgSrc });
      return true;
    });
  }

  onUploadImgFormatError(msg: string) {
    this.errorMessage = 'å¾çæ ¼å¼ä¸å¯¹ï¼æ¯æ' + this.imgFormat.split('|').join('ã');
    this.onUploadError.next(this.errorMessage);
    this.emitChange({ file: null, src: null });
  }

  onCurrentImgClick() {
    this.onImgClicked.next({file: this.currentImgFile, src: this.currentImgSrc});
  }

  writeValue(obj: any): void {
    if (obj) {
      this.currentImgFile = obj.file;
      this.currentImgSrc = obj.src;
    } else {
      this.currentImgFile = null;
      this.currentImgSrc = null;
    }
  }

  validate(control: AbstractControl): ValidationErrors {
    if (this.isRequired) {
      if (control && control.value && !control.value.file && !control.value.src) {
        return { 'imgError': true };
      }

      if (control && !control.value) {
        return { 'imgError': true };
      }
    }

    return null;
  }

  registerOnChange(fn: any): void {
    this.emitChange = fn;
  }

  registerOnTouched(fn: any): void { }

  setDisabledState?(isDisabled: boolean): void { }
}